import { useCallback, useTransition } from 'react'
import { useTimer } from 'use-timer'

import { delay } from '@/lib'

export type UseRefreshingOptions = {
  throttle?: boolean
  throttleSeconds?: number
}

export const useRefreshing = (
  refreshFn: () => any | Promise<any>,
  options: UseRefreshingOptions
): [() => Promise<void>, boolean, boolean] => {
  const { throttle, throttleSeconds = 60 } = options || {}
  const [refreshing, startRefreshing] = useTransition()
  const timer = useTimer({
    endTime: throttleSeconds
  })
  const refresh = useCallback(async () => {
    if (!refreshing) {
      startRefreshing(() => {})

      if (!throttle) {
        await refreshFn()
      } else if (timer.status !== 'RUNNING') {
        timer.start()
        await refreshFn()
      } else {
        await delay(1000)
      }
    }
  }, [refreshFn, refreshing, throttle, timer])

  return [refresh, refreshing, timer.status === 'RUNNING']
}
